<section class="clinical-trends-list-wrapper" [class.hide-panel]="!showListPanel">
    <div class="list-header-actions">
        <dls-searchbox *ngIf="listConfig?.showSearch && showListPanel" (search)="searchText = $event">
            <input dlsInput [ngModel]="searchText" [value]="searchText" placeholder="{{placeHolderText | stringTranslate}}"
                   (ngModelChange)="searchText=$event;">
        </dls-searchbox>
        <dls-icon (click)="showHideListPanel()" [class.icon__NavigationLeft1]="showListPanel"
                  [class.icon__NavigationRight]="!showListPanel"></dls-icon>
    </div>
    <dls-accordion [allowMultipleExpanded]="listConfig?.allowMultipleExpanded">
        <dls-expander [expanded]="true" *ngFor="let type of _types" [header]="type?.title | stringTranslate">
            <div *ngFor="let label of type?.prettyLabels | filter: filterTrends" genTooltip [tooltipShow]="true" [tooltipHtml]="label?.tooltipText" [tooltipPosition]="'BOTTOM'" [appendToBody]="true"> 
                <dls-check-box [(ngModel)]="label.selected"
                               (change)="onSelected($event, type, label)">{{label?.displayName}}</dls-check-box>
            </div>
        </dls-expander>
    </dls-accordion>
</section>


